/* Form Component in the DayPage to create a Schedule Scene 
   both from prefilled data from the Scene and from a number of new inputs 
 * Contains functions to display scenes by Act or Location Order
 * Once a Scene is selected it passes the scene data and the postData state
   to ScheduleSceneItem component
 * The ScheduleSceneItem component prefills the postData state
   with the main Scene data  */
import React, { useState } from "react";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import ScheduleSceneItem from "./ScheduleSceneItem";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import { Dropdown } from "react-bootstrap";
import styles from "../../../styles/ScheduleCreate.module.css";
import btnStyles from "../../../styles/Button.module.css";
import { useLocationsContext } from "../../../contexts/Scene_chars_locs";

const SceneScheduleCreate = ({
  xday,
  xdate,
  setShow,
  setHasOrder,
  epi,
  project,
  episodeTitle,
  day_id,
}) => {
  const host = useHostName();
  const currentUser = useCurrentUser();
  const [errors, setErrors] = useState({});
  const { id } = useParams();
  const [query, setQuery] = useState("");
  const [scenes, setScenes] = useState({ results: [] });
  const [click, setClick] = useState(false);
  const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser?.project_category_type)
    : null;

  const locations = useLocationsContext();

  const [postData, setPostData] = useState({
    scene_id: "",
    day_order_number: "",
    number: "",
    act: "",
    start_time: "",
    end_time: "",
    int_ext: "",
    day_night: "",
    pages: "",
    action: "",
    dramatic_day: "",
    location: "",
    title: "",
    location_detail: "",
    department_info: "",
    equip_set_props: "",
    next: "",
    new_info: "",
  });

  const [postData2, setPostData2] = useState({
    filming_location: "",
    location_address: "",
    time: "",
  });

  const {
    day_order_number,
    // scene_id,
    number,
    act,
    title,
    int_ext,
    start_time,
    end_time,
    day_night,
    action,
    pages,
    dramatic_day,
    location,
    location_detail,
    equip_set_props,
    department_info,
    next,
    new_info,
  } = postData;

  const {
    filming_location,
    location_address,
    time,
  } = postData2;

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    });
  };

  const setData = (location) => {
    /* Function to set location values automatically
         when a location is selected from the dropdown
         filming_address2 is being used for filming name */
    const filming_location = location.filming_address2 || "";
    const location_address = location.filming_address_primary || "";
    const time = location.description || "";

    setPostData2({
      filming_location: filming_location,
      location_address: location_address,
      time: time,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    if (day_order_number === "" || !day_order_number) {
      toast.error("Day Order Number is required");
      return;
    }

    formData.append("scene_id", postData.scene_id);
    formData.append("day_id", id);
    formData.append("day", xday);
    formData.append("date", xdate);
    formData.append("day_order_number", day_order_number);
    formData.append("number", number);
    formData.append("act", act);
    formData.append("title", title);
    formData.append("start_time", start_time);
    formData.append("end_time", end_time);
    formData.append("int_ext", int_ext);
    formData.append("day_night", day_night);
    formData.append("time", time);
    formData.append("pages", pages);
    formData.append("action", action);
    formData.append("dramatic_day", dramatic_day);
    formData.append("location", location);
    formData.append("location_detail", location_detail);
    formData.append("filming_location", filming_location);
    formData.append("location_address", location_address);
    formData.append("equip_set_props", equip_set_props);
    formData.append("department_info", department_info);
    formData.append("next", next);
    formData.append("new_info", new_info);
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.post("/schedule/scenes/", formData);
        setShow(false);
        setHasOrder(true);
        toast.success(`Schedule Scene Added`);
      } else {
        await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/schedule/scenes/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setShow(false);
        setHasOrder(true);
        toast.success(`Schedule Scene Added Successfully!`);
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status !== 401) {
        setErrors(err.response?.data);
      }
    }
  };

  const textFields = (
    <div>
      {/* order start est */}
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
        <Form.Group controlId="day_order_number" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >
                <span className= "d-md-none">Order Number</span>
                <span className="d-none d-md-block">Day Order Number</span>
                </Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="day_order_number"
              value={day_order_number}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.day_order_number?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={6} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="start_time" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Start Time</Form.Label>
              <Form.Control 
              className={`${styles.Input}`}
              type="text"
              name="start_time"
              value={start_time}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.start_time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={6} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="end_time" className={`${styles.Width2} `}  >
              <Form.Label className={`${styles.BoldScene}`} >Est. Time</Form.Label>
              <Form.Control
              className={`${styles.Input}`} 
              type="text"
              name="end_time"
              value={end_time}
              onChange={handleChange}
                  />
          </Form.Group>
          {errors?.end_time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      {/* hr */}
      <hr/>
      <p className={`${styles.Small} text-center pb-2`}>Select the Scene's Location to 
        autofill the Filming Location Details from its Location page.
      </p>
      {/* Location Address Dropdown */}
      <Row>
      <Col md={12} className="d-flex justify-content-center p-2">
      <Dropdown className={`${styles.Add }`}>
          <Dropdown.Toggle variant="info" id="dropdown-basic" size="sm">
            Filming Location
          </Dropdown.Toggle>
          <Dropdown.Menu className={`pt-1 pl-2 ${styles.DropButt}`}>
          {locations.results.length && (
                locations.results.map((location) => (
                  <Dropdown.Item onClick={() => setData(location) } 
                  key={location.id} >{location.name}</Dropdown.Item>
                ) )) }
          </Dropdown.Menu>
      </Dropdown>
      </Col>
      </Row>
      {/* filming location name - address */}
      <Row>
      <Col md={{span: 6, offset: 3}} className="d-flex justify-content-center p-0 p-md-2">
        <Form.Group controlId="filming_location" className={`${styles.Width2} `}  >
            <Form.Label >
              <p className={`${styles.BoldScene}`}>Filming Location Name</p>
            </Form.Label>
            <Form.Control 
            className={`${styles.Input}`}
            type="text"
            name="filming_location"
            value={filming_location}
            onChange={handleChange}
                />
        </Form.Group>
        {errors?.filming_location?.map((message, idx) => (
          <Alert variant="warning" key={idx}>
            {message}
          </Alert>
        ))}
      </Col>
      </Row>
      {/* hr */}
      <hr className={` mt-1 mb-1`}/>
      {/* filming location - address - notes */}
      <Row>
      {/* Location Address */}
      <Col md={6} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="location_address" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Filming Location Address</Form.Label>
          <Form.Control 
          className={`${styles.InputScene}`}
          type="text"
          name="location_address"
          as="textarea"
          rows={3}
          value={location_address}
          onChange={handleChange}
              />
      </Form.Group>
      {errors?.location_address?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col> 
      {/* Location notes */}
      <Col md={6} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="time" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene}`} >Parking/Directions/Notes</Form.Label>
          <Form.Control 
          className={`${styles.InputScene}`}
          type="text"
          name="time"
          as="textarea"
          rows={3}
          value={time}
          onChange={handleChange}
              />
      </Form.Group>
      {errors?.time?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col> 
      </Row>
      {/* hr */}
      <hr className={` mt-1 mb-1`}/>
      {/* new info Para2Sh */}
      <Row>
      <Col md={6} className="d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="new_info" className={`${styles.Width2} `}  >
          <Form.Label className={`${styles.BoldScene} pb-3`}>New Info</Form.Label>
          <Form.Control 
              className={`${styles.InputScene}`}
              type="text"
              name="new_info"
              as="textarea"
              rows={1}
              value={new_info}
              onChange={handleChange}
              />
          </Form.Group>
          {errors?.new_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
      </Col>
      <Col md={6} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
      <Form.Group controlId="next" className={`${styles.Width2} `}  >
          <Form.Label >
            <p className={`${styles.BoldScene}`}>Next</p>
            <p className={`${styles.Small}`}>Add Moves and Meal Breaks here</p>
            </Form.Label>
          <Form.Control 
              className={`${styles.InputSceneNext}`}
              type="text"
              name="next"
              as="textarea"
              rows={1}
              value={next}
              onChange={handleChange}
              />
      </Form.Group>
      {errors?.next?.map((message, idx) => (
        <Alert variant="warning" key={idx}>
          {message}
        </Alert>
      ))}
      </Col>
      </Row>
      {/* hr */}
      <hr className="mt-1 mb-1"/>
    </div>
  )

  const buttons = (  
    <div className="mt-4">
    <Button
      className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
      onClick={() => setShow(show => !show)}
    >
      Cancel
    </Button>
    <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
      Submit
    </Button>
    </div>
);

  /* The following 5 function fetch scenes by Act or Location order */
  const fetchScenesLoc = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `/scenes/?ordering=location&search=${query}`
        );
        setScenes(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/scenes/?ordering=location&search=${query}${
            epi && day_id ? `&episode_ids=${epi}&day_id=${day_id}` : ""
          }`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setScenes(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchScenesAll = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `/scenes/?&search=${query}`
        );
        setScenes(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/scenes/?&search=${query}${
            epi && day_id ? `&episode_ids=${epi}&day_id=${day_id}` : ""
          }`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setScenes(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchScenesOne = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(`/scenes/?act=one&search=${query}`);
        setScenes(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/scenes/?act=one&search=${query}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setScenes(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchScenesTwoA = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `/scenes/?act=two-a&search=${query}`
        );
        setScenes(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/scenes/?act=two-a&search=${query}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setScenes(data);
      }
    } catch (err) {}
  };

  const fetchScenesTwoB = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `scenes/?act=two-b&search=${query}`
        );
        setScenes(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/scenes/?act=two-b&search=${query}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setScenes(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchScenesThree = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq.get(
          `scenes/?act=three&search=${query}`
        );
        setScenes(data);
      } else {
        const { data } = await axiosInstance.get(
          `${localStorage.getItem(
            "projectSlug"
          )}/scenes/?act=three&search=${query}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        );
        setScenes(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  /* The following 5 function handle the click to the
     above functions to fetch scenes by Act or Location order */
  const handleClickLoc = () => {
    fetchScenesLoc();
    setClick(false);
  };

  const handleClickAll = () => {
    fetchScenesAll();
    setClick(false);
  };

  const handleClick1 = () => {
    fetchScenesOne();
    setClick(false);
  };

  const handleClick2 = () => {
    fetchScenesTwoA();
    setClick(false);
  };

  const handleClick3 = () => {
    fetchScenesTwoB();
    setClick(false);
  };

  const handleClick4 = () => {
    fetchScenesThree();
    setClick(false);
  };

  return (
    <div className="px-3 mx-md-5">
      <Row>
        <Col className={` ${styles.White} px-0`}>
       <Row>
          <Col>
            <h5 style={{ textTransform: "uppercase" }}
                    className={`mt-1 ml-5 mb-2 py-0 text-center ${styles.SubTitle}`}
                  >
                    ADD SCENE<span className={`float-right pt-1 ${styles.Close }`} 
                      onClick={() => setShow(false) } >Close</span>
                  </h5>
          </Col>
        </Row>  
      <div >
        {projectType !== "Television" ? (
          <p className={`text-center py-2 ${styles.Small} `}>
            SELECT A SCENE FROM THE ACTS OR LOCATION DROPDOWNS
            </p>
        ) : (
          <p className={`text-center py-2 ${styles.Small} `}>
            SELECT A SCENE FROM THE NUMBER OR LOCATION DROPDOWNS</p>
        )} 
        {/* acts */}
        {projectType !== "Television" && (
          <Row className="mt-3">
            <Col xs={6} md={3} className="text-center">
              <Button
                onClick={handleClick1}
                className={`${btnStyles.Button} ${btnStyles.Wide3} ${btnStyles.GreyDark}`}
              >
                Act One
              </Button>
            </Col>
            <Col xs={6} md={3} className="text-center">
              <Button
                onClick={handleClick2}
                className={`${btnStyles.Button} ${btnStyles.Wide3} ${btnStyles.GreyDark}`}
              >
                Act Two A
              </Button>
            </Col>
            <Col xs={6} md={3} className="text-center pt-2 pt-md-0">
              <Button
                onClick={handleClick3}
                className={`${btnStyles.Button} ${btnStyles.Wide3} ${btnStyles.GreyDark}`}
              >
                Act Two B
              </Button>
            </Col>
            <Col xs={6} md={3} className="text-center pt-2 pt-md-0">
              <Button
                onClick={handleClick4}
                className={`${btnStyles.Button} ${btnStyles.Wide3} ${btnStyles.GreyDark}`}
              >
                Act Three
              </Button>
            </Col>
          </Row>
        )}
        {/* Location */}
        {projectType !== "Television" && (
        <Row className="my-2">
          <Col xs={12} className="text-center">
            <Button
              onClick={handleClickLoc}
              className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.GreyDark}`}
            >
              Location
            </Button>
          </Col>
        </Row>
        )}

        {/* Location */}
        {projectType === "Television" && (
        <Row className="my-2 d-flex align-items-center">
          <Col xs={6}>
            <Button
              onClick={handleClickAll}
              className={`float-right mr-2 mr-md-2 ${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.GreyDark}`}
            >
              Number
            </Button>
          </Col>
          <Col xs={6} className="">
            <Button
              onClick={handleClickLoc}
              className={`ml-2 ml-md-5 ${btnStyles.Button} ${btnStyles.GreyDark} ${btnStyles.Wide2}`}
            >
              Location
            </Button>
          </Col>
        </Row>
        )}
        {/* search Para3Sh */}
        <p className={`text-center pt-2 ${styles.Small} `}>
            For precise search enter value before clicking above</p>
        <Row>
          <Col className="mt-2" xs={12} sm={{ span: 6, offset: 3 }}>
            <Form
              onSubmit={(event) => event.preventDefault()}
            >
              <Form.Control
              className={`${styles.InputBar}`}
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                type="text"
                placeholder="Search by scene number or location"
              />
            </Form>
          </Col>
        </Row>
        </div>
        {/* scenes */}
        {scenes.results.length ? (
            <>
            {click ? (<>
            <div className= {`mt-3 mb-4 pb-3 px-3`}>
            {/* selected */}
            <Row>
            <Col className="text-center">
            <p className= {`text-center ${styles.Para3Sh }`} >
              SCENE {number} SELECTED: <span className= {`${styles.Para3Sh }`} 
            style={{ textTransform: 'uppercase'}}>{int_ext} {location} - {day_night} {title && (`- ${title} `) } 
              </span>
              </p>
            </Col>
            </Row>
            <Row className="mt-3" >
            <Col>
            <h5 className={`d-none d-md-block text-center px-5 mb-0 ${styles.SubTitle }`}>
                SCENE {number} SHOOTING INFO </h5>
              <h5 className={`d-block d-md-none text-center px-5 mb-0 ${styles.SubTitle }`}>
                SCENE {number} </h5>
            </Col>
            </Row>
            <Form className={`text-center ${styles.White }`} onSubmit={handleSubmit}>
            <Row>
            <Col xs={12} className="p-0 p-md-2">
                {textFields}
                {buttons}
            </Col>
            </Row>
            </Form>
            </div>
            </>
        ) : (
          <>
          <div className= {`mb-4 pb-3 ${styles.ScenesBox} px-3 `}>
          <p className={`text-center py-2 ${styles.Para3Sh} `}>
            CLICK ON A SCENE THEN ADD THE SHOOTING INFO</p>
          <Row>
          {scenes.results.map((scene) => (
            <Col xs={12} md={6}>
            <ScheduleSceneItem 
                  setPostData={setPostData} 
                  setScenes={setScenes}
                  scene={scene} 
                  setClick={setClick}
                  {...scene} 
                  key={scene.id} />
            </Col>
          ))}
          </Row>
          </div>
          {/* FORM */}
          {/* <div className= {`mt-3 mb-4 pb-3`}>
          <Row className="mt-3 pt-3" >
            <Col>
            <h5 className={`d-none d-md-block text-center px-5 mb-0 ${styles.SubTitle }`}>
              SCENE {number} SHOOTING INFO </h5>
              <h5 className={`d-block d-md-none text-center px-5 mb-0 ${styles.SubTitle }`}>
                SCENE {number} </h5>
            </Col>
          </Row>
          <Form className={`text-center px-3 ${styles.White }`} onSubmit={handleSubmit}>
          <Row>
          <Col xs={12} className="p-0 p-md-2">
              {textFields}
              {buttons}
          </Col>
          </Row>
          </Form>
          </div> */}
          </>
        )}
        </>) : ("")}
      </Col>
      </Row>
      {/* break */}
      <Row className='mb-5 mt-3'>
      <Col xs={2} ></Col>
      <Col xs={8}>
      <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
      <hr className={`${styles.BreakBlack} my-0`}/>
      </Col>
      </Row>
    </div>
  );
};

export default SceneScheduleCreate;
